import { render, staticRenderFns } from "./Samples.vue?vue&type=template&id=596c193a&"
import script from "./Samples.vue?vue&type=script&lang=js&"
export * from "./Samples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports